export default {
  install(Vue, options) {
    // 定义全局方法
    Vue.prototype.$cacheData = function(key,data) {
      localStorage.setItem(key, JSON.stringify(data));
    };

    Vue.prototype.$restoreData = function(key) {
      const cachedData = localStorage.getItem(key);
      return JSON.parse(cachedData);
    };
  }
};



// WEBPACK FOOTER //
// ./src/utils/globalMethods.js